var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationHouse = function SvgSimpleIllustrationHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.875 26.633 13.133-.4v-2.806H32.377L16.234 11.294 3 23.626l2.006 2.206 11.529-10.528 15.341 11.329Z",
    fill: "#722B03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.74 20.852 4.279-4.01H5.607l.133 4.01Z",
    fill: "#F25730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.338 26.2v10.761H44.24V26.334H31.875l-15.341-11.03L5.338 26.201Z",
    fill: "#FFFAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.388 28.944v7.754h5.614v-7.684l-5.614-.07Z",
    fill: "#F25730"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.942 32.682a.568.568 0 1 0 0-1.136.568.568 0 0 0 0 1.136ZM19.377 20.25h-4.345v5.28h4.345v-5.28ZM12.025 28.805H7.68v5.28h4.345v-5.28ZM27.397 29.008H23.05v5.279h4.346v-5.28Z",
    fill: "#FFED8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.901 29.942h-9.225v6.95H41.9v-6.95Z",
    fill: "#D18000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.102 23.33 32.4 23.297l-16.043-11.93L2.823 23.765l2.306 2.173L16.494 15.11l15.24 11.295 13.434-.133-.066-2.943Z",
    stroke: "#002140",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13 25.938V36.9h39.238V26.539",
    stroke: "#002140",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.534 36.632v-6.75h9.425v6.683M32.604 32.356h9.09M32.604 34.629h9.09M14.654 36.266v-7.355h5.614v7.27",
    stroke: "#002140",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.033 32.988a.701.701 0 1 0 0-1.403.701.701 0 0 0 0 1.403ZM11.95 28.745H7.604v5.415h4.346v-5.415ZM27.69 28.745h-4.345v5.415h4.345v-5.415ZM19.534 20.224H15.19v5.415h4.345v-5.415ZM5.598 20.858v-4.076h4.411M5.933 18.586h.8",
    stroke: "#002140",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSimpleIllustrationHouse;